import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomerRegister = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/customer/login', { replace: true });
  }, [navigate]);

  return null;
};

export default CustomerRegister;
